module.exports = __webpack_public_path__ + "a8d4597d630977c489706bc727dc5dc8.png";